import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

declare const __VITE_SITE_URL__: string;

const faqData = [
  {
    q: 'Czym dokładnie jest Kakobuy Spreadsheet?',
    a: 'Kakobuy Spreadsheet to kompleksowy arkusz kalkulacyjny zawierający setki sprawdzonych linków do produktów z chińskich platform zakupowych, takich jak Taobao, Weidian i 1688. Każdy produkt jest dokładnie opisany, zawiera informacje o cenie, jakości, czasie wysyłki oraz ocenach innych użytkowników. To nieocenione narzędzie dla każdego, kto chce bezpiecznie i efektywnie robić zakupy w Chinach.',
  },
  {
    q: 'Czy Kakobuy Spreadsheet jest darmowy?',
    a: 'Tak, podstawowa wersja arkusza Kakobuy jest całkowicie darmowa. Oferujemy również wersję premium z dodatkowymi funkcjami, takimi jak wcześniejszy dostęp do nowych produktów, ekskluzywne kody rabatowe i priorytetowe wsparcie. Wersja darmowa zawiera jednak wszystkie niezbędne informacje do rozpoczęcia udanych zakupów.',
  },
  {
    q: 'Jak często aktualizowany jest spreadsheet?',
    a: 'Nasz zespół aktualizuje Kakobuy Spreadsheet co tydzień. Regularnie sprawdzamy wszystkie linki, usuwamy niedziałające, dodajemy nowe produkty i aktualizujemy ceny. W przypadku wykrycia problemów z jakością produktu lub sprzedawcą, natychmiast oznaczamy to w arkuszu, aby chronić naszych użytkowników.',
  },
  {
    q: 'Czy mogę ufać produktom z arkusza?',
    a: 'Absolutnie tak. Każdy produkt w naszym spreadsheetzie przechodzi proces weryfikacji. Sprawdzamy opinie sprzedawców, jakość produktów na podstawie zdjęć QC (Quality Control), czas wysyłki oraz opinie innych kupujących. Dodatkowo oznaczamy produkty, które zostały osobiście przetestowane przez nasz zespół.',
  },
  {
    q: 'Jak długo trwa dostawa do Polski?',
    a: 'Standardowy czas dostawy z Chin do Polski wynosi od 10 do 20 dni roboczych, w zależności od wybranej metody wysyłki. Kakobuy oferuje kilka opcji dostawy: ekonomiczną (15-25 dni), standardową (10-18 dni) oraz ekspresową (5-10 dni). W naszym spreadsheetzie znajdziesz również szacunkowe czasy dostawy dla każdego produktu.',
  },
];

export default function ArticlePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const siteUrl = typeof __VITE_SITE_URL__ !== 'undefined' ? __VITE_SITE_URL__ : 'https://kakobuy.click';
  const articleUrl = `${siteUrl}/artykul/najlepszy-kakobuy-spreadsheet-2026`;
  const articleImage = "https://readdy.ai/api/search-image?query=Professional%20modern%20workspace%20with%20an%20open%20laptop%20displaying%20a%20spreadsheet%20interface%20on%20a%20clean%20oak%20wooden%20desk%20with%20a%20notepad%20and%20coffee%20cup%20warm%20natural%20daylight%20from%20window%20creating%20soft%20shadows%20productive%20data%20analysis%20concept%20editorial%20photography&width=800&height=500&seq=article-main-spreadsheet&orientation=landscape";

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Strona główna',
        item: siteUrl,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Najlepszy Kakobuy Spreadsheet 2026',
        item: articleUrl,
      },
    ],
  };

  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <article className="pt-20 md:pt-24">
        {/* Breadcrumb */}
        <div className="w-full px-4 md:px-8 lg:px-12 py-4">
          <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-xs text-foreground-400">
            <Link to="/" className="hover:text-foreground-600 transition-colors cursor-pointer">Strona główna</Link>
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </span>
            <span className="text-foreground-600 font-medium">Najlepszy Kakobuy Spreadsheet 2026</span>
          </nav>
        </div>

        {/* Hero section */}
        <header className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-16 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-5">
              <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">Poradnik</span>
              <span className="text-xs text-foreground-400">21 czerwca 2026</span>
              <span className="text-xs text-foreground-400">15 min czytania</span>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-5">
              Najlepszy Kakobuy Spreadsheet 2026 – Kompletny Przewodnik po Zakupach z Chin
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-3xl">
              Dowiedz się, jak efektywnie korzystać z Kakobuy Spreadsheet, aby znaleźć najlepsze produkty, zaoszczędzić pieniądze i bezpiecznie zamawiać z chińskich platform zakupowych. Kompletny przewodnik dla początkujących i zaawansowanych użytkowników.
            </p>
          </div>
        </header>

        <div className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-14">

              {/* Sidebar TOC */}
              <aside className="lg:w-64 shrink-0">
                <div className="sticky top-24 p-5 rounded-xl bg-background-100 border border-background-200/50">
                  <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Spis treści</h4>
                  <nav className="flex flex-col gap-2">
                    {[
                      'Czym jest Kakobuy Spreadsheet?',
                      'Dlaczego warto używać arkusza?',
                      'Jak rozpocząć zakupy na Kakobuy?',
                      'Najlepsze kategorie produktów',
                      'Porównanie platform zakupowych',
                      'Bezpieczeństwo i ochrona kupującego',
                      'Koszty wysyłki i cła',
                      'Najczęściej zadawane pytania',
                    ].map((item, i) => (
                      <a
                        key={i}
                        href={`#section-${i + 1}`}
                        className="text-xs text-foreground-500 hover:text-accent-600 transition-colors leading-relaxed cursor-pointer"
                      >
                        {item}
                      </a>
                    ))}
                  </nav>
                </div>
              </aside>

              {/* Main Content */}
              <div className="flex-1 min-w-0">

                {/* Section 1 */}
                <section id="section-1" className="mb-12">
                  <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                    Czym jest Kakobuy Spreadsheet i dlaczego zrewolucjonizował zakupy z Chin?
                  </h2>
                  <div className="space-y-4">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Kakobuy Spreadsheet to nie zwykły arkusz kalkulacyjny — to kompleksowe narzędzie, które całkowicie zmienia sposób, w jaki Polacy robią zakupy na chińskich platformach. Wyobraź sobie miejsce, gdzie setki starannie wyselekcjonowanych produktów są posegregowane, opisane i ocenione przez ekspertów. Każdy link został zweryfikowany, każda cena potwierdzona, a każdy sprzedawca sprawdzony pod kątem wiarygodności. To właśnie Kakobuy Spreadsheet.
                    </p>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      W przeciwieństwie do samodzielnego przeszukiwania Taobao czy Weidian, gdzie można spędzić godziny na przeglądaniu tysięcy ofert o wątpliwej jakości, Kakobuy Spreadsheet oferuje gotową, przefiltrowaną listę najlepszych produktów. Znajdziesz tu wszystko: od limitowanych sneakersów, przez markowe ubrania, aż po elektronikę i akcesoria. Arkusz jest regularnie aktualizowany, a użytkownicy mogą zgłaszać swoje znaleziska, co sprawia, że baza produktów stale rośnie.
                    </p>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      To, co wyróżnia Kakobuy Spreadsheet na tle innych podobnych narzędzi, to przede wszystkim <strong>transparentność i zaufanie</strong>. Każdy produkt posiada szczegółowe informacje: zdjęcia QC (Quality Control), rzeczywiste wymiary, wagę, szacunkowy koszt wysyłki oraz oceny od innych kupujących. Dzięki temu unikasz nieprzyjemnych niespodzianek, takich jak produkt niezgodny z opisem czy ukryte opłaty. W świecie zakupów z Chin, gdzie oszustwa są niestety powszechne, Kakobuy Spreadsheet jest jak latarnia morska prowadząca do bezpiecznego portu.
                    </p>
                  </div>
                </section>

                {/* Section 2 */}
                <section id="section-2" className="mb-12">
                  <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                    Dlaczego warto używać Kakobuy Spreadsheet zamiast szukać samodzielnie?
                  </h2>
                  <div className="space-y-4">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Samodzielne zakupy na chińskich platformach mogą być przytłaczające. Setki tysięcy ofert, nieczytelne opisy w języku chińskim, niepewni sprzedawcy i ryzyko otrzymania produktu niskiej jakości. Kakobuy Spreadsheet eliminuje te wszystkie problemy, oferując gotowe rozwiązanie.
                    </p>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Korzystając z arkusza, <strong>oszczędzasz średnio 5-10 godzin miesięcznie</strong>, które normalnie spędziłbyś na przeszukiwaniu forów, grup na Discordzie i platform zakupowych. Wszystkie informacje masz w jednym miejscu — posegregowane według kategorii, z jasnymi oznaczeniami jakości i sprawdzonymi linkami. To jak posiadanie osobistego asystenta zakupowego, który wykonał całą ciężką pracę za Ciebie.
                    </p>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Co więcej, społeczność skupiona wokół Kakobuy Spreadsheet jest niezwykle aktywna i pomocna. Użytkownicy dzielą się swoimi doświadczeniami, zdjęciami otrzymanych produktów i wskazówkami dotyczącymi wysyłki. To tworzy swoisty ekosystem wzajemnej pomocy, gdzie zarówno początkujący, jak i doświadczeni kupujący mogą znaleźć wartościowe informacje.
                    </p>
                  </div>
                </section>

                {/* Section 3 */}
                <section id="section-3" className="mb-12">
                  <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                    Jak rozpocząć zakupy na Kakobuy — krok po kroku
                  </h2>
                  <div className="space-y-4">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Rozpoczęcie przygody z Kakobuy i korzystanie ze Spreadsheeta jest prostsze niż myślisz. Oto szczegółowa instrukcja, która przeprowadzi Cię przez cały proces — od rejestracji po otrzymanie pierwszej paczki.
                    </p>
                    <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-800 mt-6 mb-3">Krok 1: Rejestracja na Kakobuy</h3>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Pierwszym krokiem jest założenie konta na platformie Kakobuy. Proces rejestracji jest prosty i intuicyjny — wystarczy podać adres e-mail i ustawić hasło. Po weryfikacji adresu e-mail zyskujesz dostęp do pełnej funkcjonalności platformy, w tym do panelu zamówień, śledzenia przesyłek i komunikacji z agentem zakupowym.
                    </p>
                    <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-800 mt-6 mb-3">Krok 2: Pobranie i zapoznanie się ze Spreadsheetem</h3>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Po zalogowaniu się na swoje konto, przejdź do sekcji Spreadsheet. Znajdziesz tam aktualną wersję arkusza podzieloną na kategorie: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes i OtherStuff. Każda kategoria zawiera od kilkudziesięciu do kilkuset produktów.
                    </p>
                    <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-800 mt-6 mb-3">Krok 3: Wybór produktów i złożenie zamówienia</h3>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Przeglądaj interesujące Cię kategorie, porównuj produkty według ceny, jakości i ocen innych użytkowników. Gdy znajdziesz produkt, który Ci się podoba, skopiuj link i wklej go w panelu zamówień Kakobuy. Agent zakupowy zajmie się resztą — zakupem produktu, sprawdzeniem jakości i wysyłką do Polski.
                    </p>
                    <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-800 mt-6 mb-3">Krok 4: Śledzenie przesyłki i odbiór</h3>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Po złożeniu zamówienia możesz śledzić jego status w panelu Kakobuy. Otrzymasz powiadomienia o każdym etapie: zakup przez agenta, dotarcie do magazynu, zdjęcia QC, wysyłka międzynarodowa i dostawa do Polski. Cały proces jest w pełni transparentny.
                    </p>
                  </div>
                </section>

                {/* Section 4 */}
                <section id="section-4" className="mb-12">
                  <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                    Najlepsze kategorie produktów dostępne w Kakobuy Spreadsheet
                  </h2>
                  <div className="space-y-4">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Kakobuy Spreadsheet oferuje imponującą gamę kategorii produktowych. Niezależnie od tego, czy szukasz najnowszych sneakersów, ciepłej bluzy na zimę, czy stylowych akcesoriów — znajdziesz to wszystko w jednym miejscu. Oto przegląd najpopularniejszych kategorii:
                    </p>
                    <div className="overflow-x-auto my-6">
                      <table className="w-full text-sm border-collapse">
                        <thead>
                          <tr className="border-b border-background-200">
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Kategoria</th>
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Liczba produktów</th>
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Średnia cena</th>
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Ocena</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            ['Shoes', '250+', '150-400 zł', '9.2/10'],
                            ['Hoodies/Sweaters', '180+', '80-200 zł', '9.0/10'],
                            ['T-Shirts', '300+', '30-80 zł', '8.8/10'],
                            ['Jackets', '120+', '150-500 zł', '9.1/10'],
                            ['Pants/Shorts', '200+', '60-180 zł', '8.7/10'],
                            ['Accessories', '350+', '20-150 zł', '8.9/10'],
                            ['Bags', '100+', '80-300 zł', '9.0/10'],
                            ['Jersey', '90+', '100-250 zł', '8.6/10'],
                          ].map((row, i) => (
                            <tr key={i} className="border-b border-background-100 hover:bg-background-50 transition-colors">
                              {row.map((cell, j) => (
                                <td key={j} className="py-3 px-4 text-foreground-600">{cell}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Każda z tych kategorii jest regularnie aktualizowana o nowe produkty. Największą popularnością cieszą się <strong>buty (Shoes)</strong> — szczególnie limitowane edycje sneakersów, które często są niedostępne w Polsce. Drugie miejsce zajmują <strong>T-shirty</strong>, gdzie za ułamek ceny można znaleźć wysokiej jakości koszulki znanych marek.
                    </p>
                  </div>
                </section>

                {/* Section 5 */}
                <section id="section-5" className="mb-12">
                  <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                    Porównanie platform: Kakobuy kontra konkurencja
                  </h2>
                  <div className="space-y-4">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Na rynku agentów zakupowych z Chin istnieje kilka platform, ale Kakobuy wyróżnia się na ich tle pod wieloma względami. Oto szczegółowe porównanie:
                    </p>
                    <div className="overflow-x-auto my-6">
                      <table className="w-full text-sm border-collapse">
                        <thead>
                          <tr className="border-b border-background-200">
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Platforma</th>
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Ceny</th>
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Wysyłka</th>
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Interfejs</th>
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Ocena</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            ['Kakobuy', '9/10', '8/10', '9/10', '9.0'],
                            ['Pandabuy', '8/10', '8/10', '9/10', '8.5'],
                            ['CNFans', '8/10', '7/10', '8/10', '8.0'],
                            ['Superbuy', '7/10', '9/10', '7/10', '7.8'],
                            ['Hoobuy', '8/10', '7/10', '8/10', '7.9'],
                          ].map((row, i) => (
                            <tr key={i} className={`border-b border-background-100 hover:bg-background-50 transition-colors ${i === 0 ? 'bg-accent-50/50' : ''}`}>
                              {row.map((cell, j) => (
                                <td key={j} className={`py-3 px-4 ${j === 0 && i === 0 ? 'font-semibold text-accent-700' : 'text-foreground-600'}`}>{cell}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Jak widać, <strong>Kakobuy osiąga najlepszy ogólny wynik 9.0/10</strong>, wyprzedzając takie platformy jak Pandabuy (8.5/10) czy CNFans (8.0/10). Szczególnie wyróżnia się w kategorii cen i interfejsu użytkownika, co czyni go idealnym wyborem zarówno dla początkujących, jak i zaawansowanych kupujących.
                    </p>
                  </div>
                </section>

                {/* Section 6 */}
                <section id="section-6" className="mb-12">
                  <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                    Bezpieczeństwo zakupów i ochrona kupującego na Kakobuy
                  </h2>
                  <div className="space-y-4">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Bezpieczeństwo to jeden z najważniejszych aspektów zakupów online, szczególnie gdy zamawiasz produkty z drugiego końca świata. Kakobuy oferuje kompleksowy system ochrony kupującego, który minimalizuje ryzyko i daje Ci spokój ducha podczas całego procesu zakupowego.
                    </p>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      <strong>System ochrony kupującego Kakobuy</strong> obejmuje kilka kluczowych elementów. Po pierwsze, każdy produkt przed wysyłką przechodzi kontrolę jakości (QC). Agent Kakobuy sprawdza, czy produkt jest zgodny z opisem, nie ma widocznych wad i odpowiada zdjęciom z oferty. Jeśli produkt nie spełnia standardów, masz prawo do zwrotu lub wymiany.
                    </p>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Po drugie, <strong>Kakobuy oferuje gwarancję zwrotu pieniędzy</strong> w przypadku, gdy produkt nie dotrze w ciągu 60 dni lub okaże się podrobiony. To znacznie więcej niż oferuje większość konkurencyjnych platform. Dodatkowo, możesz wykupić ubezpieczenie przesyłki, które chroni Cię na wypadek zagubienia lub uszkodzenia paczki podczas transportu.
                    </p>
                  </div>
                </section>

                {/* Section 7 */}
                <section id="section-7" className="mb-12">
                  <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
                    Koszty wysyłki, cła i VAT — co musisz wiedzieć zamawiając do Polski
                  </h2>
                  <div className="space-y-4">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Zamawianie produktów z Chin do Polski wiąże się z dodatkowymi kosztami, które warto uwzględnić w swoim budżecie. Oto szczegółowe zestawienie wydatków:
                    </p>
                    <div className="overflow-x-auto my-6">
                      <table className="w-full text-sm border-collapse">
                        <thead>
                          <tr className="border-b border-background-200">
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Metoda wysyłki</th>
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Czas dostawy</th>
                            <th className="text-left py-3 px-4 text-foreground-800 font-semibold text-xs uppercase tracking-wider">Koszt (za kg)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            ['Ekonomiczna (China Post)', '15-25 dni', '30-50 zł'],
                            ['Standardowa (EMS)', '10-18 dni', '55-80 zł'],
                            ['Ekspresowa (DHL/FedEx)', '5-10 dni', '90-140 zł'],
                            ['Linia preferencyjna (EU Tax-Free)', '12-20 dni', '60-90 zł'],
                          ].map((row, i) => (
                            <tr key={i} className="border-b border-background-100 hover:bg-background-50 transition-colors">
                              {row.map((cell, j) => (
                                <td key={j} className="py-3 px-4 text-foreground-600">{cell}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                      Pamiętaj, że od 2021 roku wszystkie przesyłki spoza UE podlegają opłacie VAT (23% w Polsce). <strong>Warto korzystać z linii tax-free</strong> oferowanych przez Kakobuy, gdzie VAT jest już wliczony w koszt wysyłki, co pozwala uniknąć dodatkowych opłat celnych i przestojów na granicy. Dla przesyłek o wartości powyżej 150 EUR może zostać naliczone również cło, którego stawka zależy od kategorii produktu.
                    </p>
                  </div>
                </section>

                {/* FAQ Section */}
                <section className="mb-12">
                  <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-6">
                    Najczęściej zadawane pytania (FAQ)
                  </h2>
                  <div className="space-y-3">
                    {faqData.map((faq, idx) => (
                      <div key={idx} className="rounded-xl bg-background-100 border border-background-200/50 overflow-hidden">
                        <button
                          onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                          className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                        >
                          <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                          <span className={`w-5 h-5 flex items-center justify-center shrink-0 transition-transform duration-200 ${openFaq === idx ? 'rotate-180' : ''}`}>
                            <i className="ri-arrow-down-s-line text-foreground-400"></i>
                          </span>
                        </button>
                        {openFaq === idx && (
                          <div className="px-5 pb-4">
                            <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </section>

                {/* Internal Link Back */}
                <div className="mt-10 p-6 rounded-2xl bg-accent-50 border border-accent-200/50 text-center">
                  <p className="text-sm text-foreground-600 mb-3">
                    Wróć do strony głównej, aby przeglądać wszystkie kategorie produktów
                  </p>
                  <Link
                    to="/"
                    className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-accent-500 text-white text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-home-4-line"></i>
                    </span>
                    Strona główna
                  </Link>
                </div>

                {/* CTA */}
                <div className="mt-8 p-6 md:p-8 rounded-2xl bg-background-900 text-center">
                  <h3 className="text-xl md:text-2xl font-heading font-semibold text-white mb-3">
                    Gotowy, aby zacząć zakupy?
                  </h3>
                  <p className="text-sm text-foreground-400 mb-5 max-w-md mx-auto">
                    Otwórz Kakobuy Spreadsheet i odkryj tysiące sprawdzonych produktów w najlepszych cenach.
                  </p>
                  <a
                    href="https://kaspreadsheet.com/"
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-white text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
                  >
                    Kakobuy Spreadsheet
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* FAQ Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          }),
        }}
      />

      {/* BreadcrumbList Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />

      {/* Article Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: 'Najlepszy Kakobuy Spreadsheet 2026 – Kompletny Przewodnik po Zakupach z Chin',
            description: 'Dowiedz się, jak efektywnie korzystać z Kakobuy Spreadsheet, aby znaleźć najlepsze produkty, zaoszczędzić pieniądze i bezpiecznie zamawiać z chińskich platform zakupowych.',
            image: articleImage,
            url: articleUrl,
            datePublished: '2026-06-21',
            dateModified: '2026-06-21',
            author: {
              '@type': 'Organization',
              name: 'Kakobuy Spreadsheet Polska',
              url: siteUrl,
            },
            publisher: {
              '@type': 'Organization',
              name: 'Kakobuy Spreadsheet Polska',
              url: siteUrl,
            },
            inLanguage: 'pl-PL',
            isPartOf: {
              '@type': 'WebSite',
              name: 'Kakobuy Spreadsheet Polska',
              url: siteUrl,
            },
          }),
        }}
      />

      <Footer />
    </main>
  );
}